(function ($) {
    const NAME = 'protectedInput';
    const VERSION = '1.0.0';
    const DATA_KEY = 'adx.protected-input';
    const EVENT_KEY = `.${DATA_KEY}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];
    // const DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

    const Default = {
        spinnerClass: 'fadx-spinner fadx-spin',
        iconClass: 'w-eye',
        eyeClass: 'fadx-eye',
        eyeSlashClass: 'fadx-eye-slash',

        iconTemplate: '<i class="eyeSlashClass iconClass">',
        wrapperTemplate: '<div class="wrapperClass wrapClasses"></div>',

        protectedClass: 'w-protected',
        wrapperClass: 'eye-group',
        wrapClasses: 'is-invalid a',
        ajaxClass: 'ajax-field',

        protected: '*****',

        onEyeClick: false,
        onShow: false,
        onProtect: false,
        onLoad: false,
    };

    const Event = {
        CLICK: `click${EVENT_KEY}`,
        SHOW: `show${EVENT_KEY}`,
        SHOWN: `shown${EVENT_KEY}`,
        PROTECT: `protect${EVENT_KEY}`,
        PROTECTED: `protected${EVENT_KEY}`,
        LOAD: `load${EVENT_KEY}`,
        LOADED: `loaded${EVENT_KEY}`,
    };

    class ProtectedInput {
        constructor(element, config) {
            // private
            this._isEnabled = true;
            this._isShown = false;
            this._ajaxLoaded = false;
            this._isLoading = false;

            // Protected
            this.element = $(element);
            this.config = this._getConfig(config);

            this._isDiv = this.element.is('div');

            this.wrapper = this._makeWrapper();
            this._setWrapperObserver();
            this.eye = this._makeEye();
            this.fit();

            if (this._isDiv) {
                this.element.html(this.config.protected);
                this.element.addClass(this.config.protectedClass);
            }

            this._setListeners();
        }

        static get VERSION() {
            return VERSION
        }

        static get Default() {
            return Default
        }

        static get NAME() {
            return NAME
        }

        static get DATA_KEY() {
            return DATA_KEY
        }

        static get Event() {
            return Event
        }

        static get EVENT_KEY() {
            return EVENT_KEY
        }

        enable() {
            this._isEnabled = true
        }

        disable() {
            this._isEnabled = false
        }

        toggleEnabled() {
            this._isEnabled = !this._isEnabled
        }

        getValue() {
            let value = this.element.data('value');

            if (!value) {
                value = typeof this.config.value === 'function' ?
                    this.config.value.call(this.element) :
                    this.config.value
            }

            return value
        }

        setValue(value) {
            this.config.value = value;

            if (this._isDiv) {
                this.element.html(this.config.value);
            } else {
                this.element.val(this.config.value);
            }
        }

        toggle() {
            return this._isShown ? this.protect() : this.show()
        }

        show() {
            if (this.element.hasClass(this.config.ajaxClass) && this._ajaxLoaded === false) {
                return this.ajaxLoad();
            }

            const showEvent = $.Event(Event.SHOW, {
                currentTarget: this.element
            });

            $(this.element).trigger(showEvent);

            if (showEvent.isDefaultPrevented()) {
                return;
            }

            if (typeof this.config.onShow === 'function') {
                if (this.config.onShow(this.element) === false) {
                    return;
                }
            }

            if (this._isDiv) {
                this.element.html(this.config.value);
                this.element.removeClass(this.config.protectedClass);
            } else {
                this.element.attr('type', 'text');
            }

            this.eye.removeClass(this.config.eyeSlashClass);
            this.eye.addClass(this.config.eyeClass);

            this._isShown = true;

            const shownEvent = $.Event(Event.SHOWN, {
                currentTarget: this.element
            });

            $(this.element).trigger(shownEvent);
        }

        ajaxLoad() {
            if (this._isLoading) {
                return;
            }

            const loadEvent = $.Event(Event.LOAD, {
                currentTarget: this.element
            });

            $(this.element).trigger(loadEvent);

            if (loadEvent.isDefaultPrevented()) {
                return;
            }

            if (typeof this.config.onLoad === 'function') {
                if (this.config.onLoad(this.element) === false) {
                    return;
                }
            }

            this._showSpinner();

            $.ajax({
                url: this.config.url,
                success: (data) => {
                    this.element.val(data);
                    this.config.value = data;
                    this._ajaxLoaded = true;
                },
                complete: () => {
                    this._hideSpinner();

                    const loadedEvent = $.Event(Event.LOADED, {
                        currentTarget: this.element
                    });

                    $(this.element).trigger(loadedEvent);

                    if (this._ajaxLoaded) {
                        this.show();
                    }
                }
            });
        }

        protect() {
            const protectEvent = $.Event(Event.PROTECT, {
                currentTarget: this.element
            });

            $(this.element).trigger(protectEvent);

            if (protectEvent.isDefaultPrevented()) {
                return;
            }

            if (typeof this.config.onProtect === 'function') {
                if (this.config.onProtect(this.element) === false) {
                    return;
                }
            }

            if (this._isDiv) {
                this.element.html(this.config.protected);
                this.element.addClass(this.config.protectedClass)
            } else {
                this.element.attr('type', 'password');
            }

            this.eye.addClass(this.config.eyeSlashClass);
            this.eye.removeClass(this.config.eyeClass);

            this._isShown = false;

            const protectedEvent = $.Event(Event.PROTECTED, {
                currentTarget: this.element
            });

            $(this.element).trigger(protectedEvent);
        }

        _getConfig(config) {
            const dataAttributes = $(this.element).data();

            // Object.keys(dataAttributes)
            //     .forEach((dataAttr) => {
            //         if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
            //             delete dataAttributes[dataAttr]
            //         }
            //     });

            config = {
                ...this.constructor.Default,
                ...dataAttributes,
                ...typeof config === 'object' && config ? config : {}
            };

            // if (config.sanitize) {
            //     config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn)
            // }

            return config
        }

        _setListeners() {
            let self = this;

            this.eye.click(function (e) {
                if (self._isEnabled && !e.isDefaultPrevented()) {
                    const clickEvent = $.Event(Event.CLICK, {
                        currentTarget: e.currentTarget
                    });

                    $(self.element).trigger(clickEvent);

                    if (clickEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (typeof self.config.onEyeClick === 'function') {
                        if (self.config.onEyeClick(this.element) === false) {
                            return;
                        }
                    }

                    self.toggle();
                }
            });
        }

        _makeWrapper() {
            let classes = '';

            this.config.wrapClasses.split(' ').forEach(el => {
                if (this.element.hasClass(el)) {
                    classes += ` ${el}`;
                }
            });

            this.element.wrap(
                this.config.wrapperTemplate
                    .replace('wrapperClass', this.config.wrapperClass)
                    .replace('wrapClasses', classes)
            );

            return this.element.parent();
        }

        _setWrapperObserver() {
            let observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === "class") {
                        let attributeValue = $(mutation.target).prop(mutation.attributeName);

                        this.config.wrapClasses.split(' ').forEach(el => {
                            if (attributeValue.split(' ').indexOf(el) !== -1) {
                                this.wrapper.addClass(el);
                            } else {
                                this.wrapper.removeClass(el);
                            }
                        });
                    }
                });
            });

            observer.observe(this.element[0], { attributes: true });
        }

        _makeEye() {
            $(this).parent().append('<i class="fadx-eye-slash w-eye">');

            this.wrapper.append(
                this.config.iconTemplate
                    .replace('eyeSlashClass', this.config.eyeSlashClass)
                    .replace('iconClass', this.config.iconClass)
            );

            return this.wrapper.find(`.${this.config.iconClass}`);
        }

        fit() {
            let baseFontSize = parseInt(this.element.css('font-size'));
            this.wrapper.css('font-size', baseFontSize);
            this.element.css('font-size', 'inherit');
        }

        _showSpinner () {
            this._isLoading = true;
            this.eye.data('last-class', this.eye.attr('class'));
            this.eye.addClass(this.config.spinnerClass);
            this.eye.removeClass(`${this.config.eyeClass} ${this.config.eyeSlashClass}`);
        }

        _hideSpinner () {
            this._isLoading = false;
            this.eye.removeClass(this.config.spinnerClass);
            this.eye.addClass(this.eye.data('last-class'));
        }

        // Static

        static _jQueryInterface(config, params) {
            return this.each(function () {
                let data = $(this).data(DATA_KEY);
                const _config = typeof config === 'object' && config;

                if (!data && /dispose|hide/.test(config)) {
                    return
                }

                if (!data) {
                    data = new ProtectedInput(this, _config);
                    $(this).data(DATA_KEY, data)
                }

                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') {
                        throw new TypeError(`No method named "${config}"`)
                    }
                    data[config](params)
                }
            })
        }

        static getInstance(element) {
            return Data.getData(element, DATA_KEY)
        }
    }

    $.fn[NAME] = ProtectedInput._jQueryInterface;
    $.fn[NAME].Constructor = ProtectedInput;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return ProtectedInput._jQueryInterface
    };
})(jQuery);